import '../assets/styles.css';
import iconA from "../assets/pad-pro-home-section-ca.png"
import iconB from "../assets/pad-pro-home-section-cb.png"
import iconC from "../assets/pad-pro-home-section-cc.png"

export default function HomeSectionC() {
  return (
    <div data-aos="fade-up">
      <div className="bg-white">
        
        {/* Self-Help Advocacy Hero Section - Enhanced responsive design */}
        <div className="py-12 sm:py-16 lg:py-20">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
            <div 
              className="flex flex-col lg:flex-row items-center lg:items-start gap-6 sm:gap-8 lg:gap-12 py-8 sm:py-12 lg:py-16 xl:py-24" 
              data-aos="fade-up" 
              data-aos-duration="2000"
            >
              {/* Title Section - Enhanced responsive typography */}
              <div className="w-full lg:w-1/2 text-center lg:text-left">
                <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl tracking-tight newsreader text-green-700 leading-tight">
                  Self-Help Advocacy
                </h1>
              </div>
              
              {/* Description Section - Enhanced spacing and typography */}
              <div className="w-full lg:w-1/2">
                <p className="text-sm sm:text-base lg:text-lg xl:text-xl text-gray-700 leading-relaxed text-center lg:text-left">
                  The overall goal of the program is to provide structure and training that empower individuals to communicate effectively and make informed choices through skill development.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Main Content Section */}
        <div className="bg-white">
          <main className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
            
            {/* Responsive Programming Section */}
            <div className="py-12 sm:py-16 lg:py-20 bg-gray-50 -mx-4 sm:-mx-6 lg:-mx-8" data-aos="fade-up" data-aos-duration="2000">
              <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
                <div className="flex flex-col lg:flex-row items-center lg:items-start gap-8 lg:gap-12 xl:gap-16">
                  
                  {/* Image */}
                  <div className="w-full lg:w-1/3 flex justify-center lg:justify-start">
                    <div className="max-w-sm sm:max-w-md lg:max-w-full">
                      <img 
                        src={iconA} 
                        alt="Responsive Programming - Communication device and positive behavior chart" 
                        className="w-full h-auto rounded-lg shadow-lg transition-transform duration-300 hover:scale-105"
                      />
                    </div>
                  </div>

                  {/* Content */}
                  <div className="w-full lg:w-2/3">
                    <h2 className="text-2xl sm:text-3xl lg:text-4xl text-gray-900 newsreader mb-4 sm:mb-6 text-center lg:text-left leading-tight">
                      Responsive Programming
                    </h2>
                    <div className="space-y-4 sm:space-y-6 text-gray-700 text-sm sm:text-base lg:text-lg leading-relaxed">
                      <p>
                        Piedmont Adult Day Program <span className='text-[#2E7D32] font-semibold'>Self-Help Advocacy through Responsive Programming (S.H.A.R.P.)</span> integrates proactive, reactive, and interactive approaches to foster personal development and behavioral transformation.
                      </p>
                      <p>
                        The program aims to address inappropriate behaviors by using the ABC approach to managing behaviors, monitor antecedents, reduce behavior occurrence through intervention plans and reinforcements, and replace them with constructive skills that can evolve into productive activities. By prioritizing individual preferences, needs and interests, S.H.A.R.P. emphasizes building responsibility and developing essential skills for independence. This comprehensive framework not only addresses current behavioral challenges but also <span className='text-[#2E7D32] font-semibold'>prepares individuals for a self-reliant future</span> through personalized, goal-oriented strategies.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Communication of Behavior Section */}
            <div className="py-12 sm:py-16 lg:py-20 bg-white" data-aos="fade-up" data-aos-duration="2000">
              <div className="flex flex-col lg:flex-row items-center lg:items-start gap-8 lg:gap-12 xl:gap-16">
                
                {/* Content - Left side on desktop, top on mobile */}
                <div className="w-full lg:w-2/3 order-2 lg:order-1">
                  <h2 className="text-2xl sm:text-3xl lg:text-4xl text-gray-900 newsreader mb-4 sm:mb-6 text-center lg:text-left leading-tight">
                    Communication of Behavior
                  </h2>
                  <div className="space-y-4 sm:space-y-6 text-gray-700 text-sm sm:text-base lg:text-lg leading-relaxed">
                    <p>
                      The Piedmont Adult Day Program <span className='text-[#2E7D32] font-semibold'>recognizes that the inability to effectively communicate needs is a primary cause of many maladaptive behaviors</span>, which often serve as an alternative means of communication.
                    </p>
                    <p>
                      The program's teaching principles are encapsulated in the <span className='text-[#2E7D32] font-semibold'>"CON ON THE C.O.B."</span> initiative, which stands for Concentrating on the Communication of Behavior, emphasizing the importance of addressing behavior as a form of communication.
                    </p>
                  </div>
                </div>

                {/* Image - Right side on desktop, bottom on mobile */}
                <div className="w-full lg:w-1/3 order-1 lg:order-2 flex justify-center lg:justify-end">
                  <div className="max-w-sm sm:max-w-md lg:max-w-full">
                    <img 
                      src={iconB} 
                      alt="Communication of Behavior - Staff and participant using communication board" 
                      className="w-full h-auto rounded-lg shadow-lg transition-transform duration-300 hover:scale-105"
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* Hands-on Experience Section */}
            <div className="py-12 sm:py-16 lg:py-20 bg-gray-50 -mx-4 sm:-mx-6 lg:-mx-8" data-aos="fade-up" data-aos-duration="2000">
              <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
                <div className="flex flex-col lg:flex-row items-center lg:items-start gap-8 lg:gap-12 xl:gap-16">
                  
                  {/* Image */}
                  <div className="w-full lg:w-1/3 flex justify-center lg:justify-start">
                    <div className="max-w-sm sm:max-w-md lg:max-w-full">
                      <img 
                        src={iconC} 
                        alt="Hands-on Experience - Participants doing community volunteer work" 
                        className="w-full h-auto rounded-lg shadow-lg transition-transform duration-300 hover:scale-105"
                      />
                    </div>
                  </div>

                  {/* Content */}
                  <div className="w-full lg:w-2/3">
                    <h2 className="text-2xl sm:text-3xl lg:text-4xl text-gray-900 newsreader mb-4 sm:mb-6 text-center lg:text-left leading-tight">
                      Hands-on Experience
                    </h2>
                    <div className="space-y-4 sm:space-y-6 text-gray-700 text-sm sm:text-base lg:text-lg leading-relaxed">
                      <p>
                        The Piedmont Adult Day Program emphasizes the <span className='text-[#2E7D32] font-semibold'>value of hands-on experiences in promoting skill acquisition</span>, incorporating volunteer jobs within the community.
                      </p>
                      <p>
                        Activities are tailored through assessments of individual interests and preferences, structured schedules, and purposeful integration to ensure a high likelihood of success. These experiences enhance quality of life while providing <span className='text-[#2E7D32] font-semibold'>opportunities for individuals to communicate effectively and demonstrate appropriate behaviors</span> aligned with workplace norms and natural environments.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </main>
        </div>
      </div>
    </div>
  );
}